var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationProvider", {
    attrs: { rules: _vm.rules, name: _vm.name, slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (validationContext) {
          return [
            _c(
              "b-form-group",
              [
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.icon,
                        expression: "icon",
                      },
                    ],
                    staticClass: "input-element-title",
                  },
                  [_vm._v(_vm._s(_vm.inputVal === "" ? "" : _vm.placeholder))]
                ),
                _vm._v(" "),
                _c(
                  "b-input-group",
                  {
                    staticClass: "border-input",
                    style: {
                      "--valid": Number(
                        _vm.$getValidationState(validationContext) ||
                          !validationContext.errors.length
                      ),
                      "--borderOpacity": _vm.icon
                        ? _vm.isActive
                          ? 1
                          : 0.6
                        : 0,
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.icon
                          ? {
                              key: "prepend",
                              fn: function () {
                                return [
                                  _c("img", {
                                    staticClass: "input-element-prepend",
                                    style: {
                                      height: _vm.iconHeight,
                                      width: _vm.iconWidth,
                                    },
                                    attrs: { src: _vm.icon },
                                  }),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                        {
                          key: "append",
                          fn: function () {
                            return [_vm._t("password")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _vm._v(" "),
                    _vm._v(" "),
                    _c("b-form-input", {
                      ref: "input",
                      class: _vm.icon ? "input-element py-0" : "no-valid py-0",
                      style: _vm.icon
                        ? ""
                        : "-webkit-text-fill-color: black !important;",
                      attrs: {
                        type: _vm.type,
                        placeholder: _vm.placeholder,
                        debounce: _vm.debounce,
                        autofocus: _vm.autofocus,
                        autocomplete: _vm.autocomplete,
                        state: !_vm.icon
                          ? _vm.validationState(validationContext)
                          : undefined,
                      },
                      on: {
                        focus: function ($event) {
                          _vm.isActive = true
                        },
                        blur: function ($event) {
                          _vm.isActive = false
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.onKeyEnterUp.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.inputVal,
                        callback: function ($$v) {
                          _vm.inputVal = $$v
                        },
                        expression: "inputVal",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "position-absolute",
                        style: _vm.warningPosition,
                      },
                      [
                        validationContext.errors[0] && _vm.icon
                          ? _c("img", {
                              attrs: {
                                id: `error${_vm.ind}`,
                                src: require("images/formIcons/failed-input.svg"),
                                width: "20px",
                                height: "20px",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        validationContext.errors[0]
                          ? _c(
                              "b-popover",
                              {
                                attrs: {
                                  triggers: "hover",
                                  target: _vm.icon
                                    ? `error${_vm.ind}`
                                    : _vm.$refs.input.$el,
                                  placement: "top",
                                  variant: "danger",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(validationContext.errors[0]) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }